export default __webpack_public_path__ + "locales/de/OAuth.json?hash=77bafcf35af41b4952e358b7e23ad9f1";